import React, {useCallback} from 'react';

import {useI18n} from '../../../../../../../data/hooks/i18nHooks';
import {useMyUserId} from '../../../../../../../data/hooks/sessionHooks';
import ContainedImage from '../../../../../../elements/ContainedImage';
import styles from '../BubbleMenu.module.scss';

const Meeting = props => {
    const {event, user} = props,
        myUserId = useMyUserId(),
        i18n = useI18n();

    const handleCreateMeeting = useCallback(() => {
        if (event && user) {
            const url = ['/events', event.id, 'participants', user.user_id || '-', user.participant_id || '-', 'invite'].join('/');
            app.history.push(`${url}?users=${user.user_id || ''}&participants=${user.participant_id || ''}`);
        }
    }, [event, user]);

    if (!event || !user) return null;
    if (event.settings.disable_meetings || !event.joined) return null;
    if (!event._isEvent) return null;
    if (user.user_id == myUserId) return null;

    return (
        <button type="button" onClick={handleCreateMeeting}>
            <span className={styles.label}>{i18n['label.send.invitation']}</span>
            <ContainedImage src="/img/eventmeeting.png" color="white" />
        </button>
    );
};

export default Meeting;
